import { request } from "../utils";
import { apis } from "../constants";
import { message } from "antd";
export const addProject = (p: ProjectFormValue) => {
    return request<Project>(apis.appProject, { data: p, method: 'post' })
}
export const addProjectUsers = (projectId: any, users: any[]) => {
    return request(apis.addProjectUser, { params: { projectId }, data: users, method: 'post' })
}

export const getProject = (projectId: number | string) => {
    return request<Project>(apis.getProject, { params: { projectId } })
}

export const updataProject = (p: Project) => {
    return request(apis.updateProject, { method: 'put', params: { projectId: p.projectId }, data: p })
}

export const deleteProject = (projectId: number) => {
    return request(apis.deleteProject, { method: 'delete', params: { projectId } })
}

export const stopProject = (projectId: number) => {
    return request(apis.stopProject, { method: 'put', params: { projectId } })
}

export type SearchProjectParams = Partial<{
    asc: boolean;
    createDateRangeEnd: string;
    createDateRangeStart: string;
    endDateRangeEnd: string;
    endDateRangeStart: string;
    organizationId: number | string;
    pageNum: number;
    pageSize: number;
    projectName: string;
    sortField: string;
    startDateRangeEnd: string;
    startDateRangeStart: string;
}>

export const searchProject = (params: SearchProjectParams, isHistory = false) => {
    return request<PagedData<Project>>( isHistory ? apis.searchHistoryProjects : apis.searchProject, { data: params, method: 'post' })
}

export const lookupAllProject = (word: string) => {
    return request<{
        "projectId": any,
        "projectName": string
      }[]>(apis.lookupAllProject, { data: {word}, method: 'post' })
}

export const uploadFile = (params: { projectId: any }, data: any) => {
    return request(apis.uploadFile, { params, data, method: 'post' })
}

export const updateFile = (projectId: string, fileId: string, data: FormData) => {
    return request(apis.updateFile, {
        method: 'put', params: { projectId, fileId }, data
    })
}

export const getFile = (projectId: any, fileId: any) => {
    return request(apis.getFile, { params: { projectId, fileId }, method: 'get' })
}

export const updateProjectGateway = async (data:any) => {
    try {
        await request(apis.updateProjectGateway, {method: 'post', data})
        message.success('修改成功')
        return true
    } catch(err) {
        message.error((err as any).message || '请求错误' )
        return false
    }
}